import * as React from 'react';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { Paper } from '@mui/material';
import { useState, useEffect } from 'react';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" color='success' />;

export default function AddNamesTable({players, removedPlayers, onSelectedPlayersChange, id}) {

    const [selectedPlayers, setSelectedPlayers] = useState([]);

    const handleSelectionChange = (event, selectedOptions) => {
      setSelectedPlayers(selectedOptions);
        onSelectedPlayersChange(selectedOptions);
    };

    useEffect(() => {
        setSelectedPlayers([]);
    }, [id])

  return (
    <Paper elevation={3} sx={{padding:2, margin:2}}>
        {players.length > 0 &&
    <Autocomplete
      multiple
      id="checkboxes-tags-demo"
      options={players}
      disableCloseOnSelect
      getOptionDisabled={(option) =>
        option === removedPlayers.find((player) => player === option)
      }
      getOptionLabel={(option) => option}
      value={selectedPlayers}
        onChange={handleSelectionChange}
      renderOption={(props, option, { selected }) => (
        <li {...props}>
          <Checkbox
            icon={icon}
            checkedIcon={checkedIcon}
            style={{ marginRight: 8 }}
            checked={selected}
          />
          {option}
        </li>
      )}
      renderInput={(params) => (
        <TextField {...params} label="Players you want" placeholder="Add Players" />
      )}
    />
      }
    </Paper>
  );
}